import { Box, Button, CircularProgress, Stack, Typography as T } from "@mui/material";

interface InitializationStatusSectionProps {
  status: string | undefined;
  loading: boolean;
  generatedAt: string;
  error: string | undefined;
  onInitialize: () => void;
  onRegenerate: () => void;
}

const InitializationStatusSection = ({
  status,
  loading,
  generatedAt,
  error,
  onInitialize,
  onRegenerate,
}: InitializationStatusSectionProps) => {
  if (loading && !status) {
    return null;
  }

  if (status === "running") {
    return (
      <Stack direction="row" alignItems="center" gap={1.5} py={2}>
        <CircularProgress size={16} />
        <T variant="body2" color="text.secondary">
          Analysis agent dataset context is being generated...
        </T>
      </Stack>
    );
  }

  if (status === "completed") {
    return (
      <Stack direction="row" alignItems="center" gap={1.5} py={2}>
        <T variant="body2" color="text.secondary">
          Analysis agent dataset context last generated: {generatedAt}
        </T>
        <Button variant="outlined" size="small" onClick={onRegenerate}>
          Regenerate
        </Button>
      </Stack>
    );
  }

  if (status === "failed") {
    return (
      <Stack gap={1} py={2}>
        <T variant="body2" color="error.main">
          Initialization failed{error ? `: ${error}` : ""}
        </T>
        <Box>
          <Button variant="outlined" size="small" onClick={onInitialize}>
            Retry
          </Button>
        </Box>
      </Stack>
    );
  }

  // not_started or undefined
  return (
    <Stack direction="row" alignItems="center" gap={1.5} py={2}>
      <T variant="body2" color="text.secondary">
        Dataset context has not been initialized.
      </T>
      <Button variant="outlined" size="small" onClick={onInitialize}>
        Initialize
      </Button>
    </Stack>
  );
};

export default InitializationStatusSection;
